import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { H, Wrapper } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'
import { screenMax } from '@farewill/ui/helpers/responsive'
import PATHS from 'lib/navigation/paths'
import ChevronSeparator from 'components/ChevronSeparator'
import YellowBanner from 'components/YellowBanner'
import { MIN_BANNER_HEIGHT } from '../constants'

const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${MIN_BANNER_HEIGHT.LARGE_SCREENS};
  max-width: 560px;
  padding-bottom: ${GTR.XXL};

  ${screenMax.s`
    min-height: ${MIN_BANNER_HEIGHT.SMALL_SCREENS};
  `}
`

const StyledBreadcrumb = styled(Link)`
  display: inline-block;
  text-decoration: none;
`

const CategoryBanner = ({
  title,
  breadcrumbs,
}: {
  title?: string
  breadcrumbs?: GatsbyTypes.ContentfulContentHubCategoryGroup[]
}): React.ReactElement => (
  <YellowBanner textureStyle="B" centered={false}>
    <StyledWrapper>
      <H context color={COLOR.BLACK}>
        {breadcrumbs && breadcrumbs.length > 0 ? (
          <ChevronSeparator>
            <StyledBreadcrumb to={PATHS.GENERAL.CONTENT_HUB}>
              Guides
            </StyledBreadcrumb>

            <StyledBreadcrumb
              to={`${PATHS.GENERAL.CONTENT_HUB}/${breadcrumbs[0]?.slug}`}
            >
              {breadcrumbs[0]?.shortTitle || breadcrumbs[0]?.title}
            </StyledBreadcrumb>
          </ChevronSeparator>
        ) : (
          <StyledBreadcrumb to={PATHS.GENERAL.CONTENT_HUB}>
            Guides
          </StyledBreadcrumb>
        )}
      </H>

      <H tag="h1" size="XL" decorative>
        {title}
      </H>
    </StyledWrapper>
  </YellowBanner>
)

export default CategoryBanner
